<template>
  <div>
    <header-sales></header-sales>
    <!-- pc view -->
    <div v-show="!mobileView"> 
        <div id="subheader"> </div>
        <div id="main-container">
        <div id="label-container">
            <span id="label">Clientes</span>
        </div>
        <div id= "container">
            <div id="list-header-container">
            <input id="busqueda" type="text" placeholder="Busqueda de clientes por nombre o código" v-model="filter">
            </div>
            <div id="list-container">
            <table v-if="filtered.length" cellspacing="20">
                <tr style="text-align: left;">
                <th width="120" colspan="2"># Código</th>
                <th>Nombre</th>
                </tr>
                <tr v-for="(item, key) of filtered" :key="key">
                <td><input type="radio" :id="`cliente-${item.Id}`" v-model="cliente" :value="item"></td>
                <td>
                    <label :for="`cliente-${item.Codigo}`">{{ item.Codigo }}</label>
                </td>
                <td>
                    <label :for="`cliente-${item.Id}`">{{ item.Nombre }}</label>
                </td>
                </tr>
            </table>
            <div v-else>
                Sin resultados ...
            </div>
            </div>
        </div>
        <div style="text-align: center;margin-top: 30px;">
            <button id="btnok" @click="next">CONTINUAR</button>
            <button id="btncancel" @click="exit" v-show='this.$store.state.user.cliente'>CANCELAR</button>
        </div>
        </div> 
     </div>


    <!-- mobile view -->
    <div v-show="mobileView" style="margin-top: 40px">
        <div class="fh cc" style="width: 100vw; height:4vh; background:#44C7F4; color:white; font: size 12px;">Clientes</div>
        <div class="fv ct" style="height:60vh;">
            <div class="fv cc" style="width: 100vw; height: 20%;">
            <input id="busqueda" type="text" style="font-size: 11px" placeholder="Busqueda de clientes por nombre o código" v-model="filter">
            </div>
            <div class="fv ct" style=" width: 100vw; height:70%; overflow:auto;">
            <table style="font-size: 12px" v-if="filtered.length" cellspacing="20">
                <tr v-for="(item, key) of filtered" :key="key">
                <td><input type="radio" :id="`cliente-${item.Id}`" v-model="cliente" :value="item"></td>
                <td>
                    <label :for="`cliente-${item.Codigo}`">{{ item.Codigo }}</label>
                </td>
                <td>
                    <label :for="`cliente-${item.Id}`">{{ item.Nombre }}</label>
                </td>
                </tr>
            </table>
            <div v-else>
                Sin resultados ...
            </div>
            </div>
        </div>
        <div class="fh cc" style="width: 100vw; height:19vh;">
          <button id="btnok" @click="next">CONTINUAR</button>
          <button id="btncancel" @click="exit" v-show='this.$store.state.user.cliente'>CANCELAR</button>
        </div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios'
import HeaderSales from '@components/views/header.vue';

export default {
  components: {
    'header-sales': HeaderSales
  },
  data () {
    return {
      filter: null,
      cliente: null,
      clientes: [],
      clienteModificado:false,
      mobileView:false
    }
  },
  computed: {

    filtered () {
      if (!this.clientes.length) {
        return []
      }

      if (this.filter) {
        return this.clientes.filter(c => (c.Codigo.indexOf(this.filter) !== -1) || (c.Nombre.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1))
      }

      return this.clientes
    }
  },
  
  mounted () {
   this.onResize()
   this.getClientes()
  },

  
  methods: {

   onResize() {
      if (window.innerWidth > 600) 
      {
        this.mobileView=false;
      }
      else 
      {
        this.mobileView=true;
      }
    },


    getClientes () {
      axios
        .get("/WebSalesClientesListado?EmpleadoId=" + this.$store.state.user.usuario.EmpleadoId, {  
          headers: {
            Token: this.$store.state.user.usuario.Token,
            ClientSecret: this.$store.state.entorno.clientSecret,
            EmpresaId:    this.$store.state.entorno.idEmpresa
          }
        })
        .then(response => {
        //   console.log(response.data.Clientes)
          this.clientes = response.data.Clientes
          this.clientes.forEach((j) => {  
            if (j.Codigo == null)
            {
              j.Codigo=" "  
            }
           if (j.Nombre == null)
            {
              j.Nombre=" "  
            }
          });  
          this.$store.commit("loader/stop");
        })
        .catch(error => {
        //   console.log('3')  
          this.$store.commit("loader/stop");
        })
    },


    next () 
    {
      if (this.cliente) 
      {
        var carrito = this.$store.state.pedido.carrito
        if ((this.$store.state.user.cliente) && ((carrito != null) && (carrito.length > 0)))
        {
            var obj = {
                       txt:'Si selecciona un nuevo cliente se eliminara el pedido en curso',
                       txtBtnCancel:'No',
                       txtBtnOk:'Nuevo Cliente',
                       fCancel:this.exit,
                       fOk:this.selectCliente
                      }
           this.$store.commit('popup/open',obj);
        }
        else
        {
           this.selectCliente()
        }
      }
    },




    exit () 
    {
      this.$router.push({ name: "home" });
    },

    selectCliente () 
    {
      this.$store.commit("pedido/eliminarPromociones");
      this.$store.commit("pedido/eliminarDescuentos");
      this.$store.commit("pedido/eliminarProductos");
      this.$store.commit("pedido/eliminarPedido");
      this.getDatosCliente(this.cliente.Id)
    },


    getDatosCliente(clienteId) 
    {
       this.$store.commit("loader/start");
       axios
        .get("/WebSalesCliente?ClienteId=" + clienteId, {
          headers: {
            Token:        this.$store.state.user.usuario.Token,
            ClientSecret: this.$store.state.entorno.clientSecret,
            EmpresaId:    this.$store.state.entorno.idEmpresa
          }
        })
        .then(
          response => {
            this.$store.commit("loader/stop");
            if (response.data.Code == 0) 
            {
              this.$store.commit("user/saveCliente",response.data);
              this.$router.push({ name: 'home' });
            }
          },
          error => {
            this.$store.commit("loader/stop");
            // console.log(response.data)
          }
        );
    },
  },

  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>


#btnok {
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}

#btncancel {
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


  #subheader {
    width: 100%;
    height: 35vh;
    background: linear-gradient(#005A9F , #1899D6);
    }


   #main-container{
    position: absolute;
    top: 55vh;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 700px;
    height: 85vh;
    }


   #label-container{
     width: 700px;
     height: 10vh;
    }

   #label{
     color:#ffffff;
     font-size: 27px;
    }


   #container{
     width: 700px;
     height: 65vh;
     border-width: 1px;
     border: 1px solid #dddddd;
     box-sizing: border-box;
     background-color: #ffffff;
    }

   #list-header-container{
     height: 13vh;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     background-color: #ffffff;
    }

   #busqueda{
    border-radius: 20px;
    max-width: 400px; 
    width: 70vw;
    margin-top:15px;
    padding-left: 40px;
    height:30px;
    border-style: solid;
    border:none;
    border-width: 1px;
    border: 1px solid #dddddd;
    color: #000000;
    outline: none;
    background: white url(/dist/icon-search.png) left no-repeat ;
    background-size: 25px 25px;
    background-position: 10px;
   }

   #seleccion-container{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    }

   .seleccion{
    color:#2292CD;
    font-weight: normal;
    margin-left:0 auto;
    margin-right: 0 auto;
    margin-top: 0px;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    }


   .seleccion:hover{
       cursor: pointer;
     }


   #separador{
    margin-left: 15px;
    margin-right: 15px;
    font-weight: 500;
    font-size: 13px;
    color:#dddddd;
    }


   #list-container{
    width: 630px;
    height: 49vh;
    margin-left: 25px;
    margin-right: 25px;
    overflow: auto;
    background-color: #ffffff;
    }



   #btnContainer{
     width: 660px;
     height: 10vh;
     display: flex;
     flex-direction:row;
     justify-content: flex-end;
     align-items: center;
    }


   #btnAgregarPromo{
     width: 120px;
     height: 30px;
     font-size: 9px;
     margin-left: 5px;
     margin-right: 5px;
     border-style: solid;
     border:none;
     color: #4969B2;
     background: #ffffff;
     border-radius: 20px;
     border-width: 1px;
     border: 1px solid #4969B2;
     outline: none;
   }


   #btnCarrito{
     width: 100px;
     height: 30px;
     margin-left: 5px;
     margin-right: 5px;
     font-size: 9px;
     border-style: solid;
     border:none;
     background: #44C7F4;
     border-radius: 20px;
     color: #ffffff;
     outline: none;
   }

   #btnok:hover{cursor: pointer;}
   #btncancel:hover{cursor: pointer;}

   .fade-enter-active, .fade-leave-active {
     transition-property: opacity;
     transition-duration: .25s;
   }

   .fade-enter-active {
     transition-delay: .25s;
   }

   .fade-enter, .fade-leave-active {
     opacity: 0}





   .fadePro-enter {
     opacity: 0;
   }
   .fadePro-enter-active {
     transition: opacity 0.5s;
   }
   .fadePro-enter-to {
     opacity: 1;
   }
   .fadePro-leave {
     opacity: 1;
   }
   .fadePro-leave-active {
     transition: opacity 0.1s;
   }
   .fadePro-leave-to {
     opacity: 0;
   }

   /*-----------------------------------------------------------------------------------------------------------------------*/

   /* width */
   ::-webkit-scrollbar {
       width: 5px;
   }

   /* Track */
   ::-webkit-scrollbar-track {
       box-shadow: inset 0 0 5px #dddddd;
       border-radius: 10px;
   }

   /* Handle */
   ::-webkit-scrollbar-thumb {
       background: #cccccc;
       border-radius: 10px;
   }

   /* Handle on hover */
   ::-webkit-scrollbar-thumb:hover {
       background: #bbbbbb;
   }



   ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
       color: #dddddd;
       opacity: 1; /* Firefox */
   }

   :-ms-input-placeholder { /* Internet Explorer 10-11 */
       color: #dddddd;
   }

   ::-ms-input-placeholder { /* Microsoft Edge */
       color: #dddddd;
   }
</style>



// WEBPACK FOOTER //
// src/components/views/preselect/clientes.vue